import React, { useCallback, useEffect } from "react";
import { useFormik } from "formik";
import { TextField } from "@mui/material";
import { FileUpload as FileUploadIcon } from "@mui/icons-material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment/moment";
import * as yup from "yup";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { BsImages } from "react-icons/bs";
import { useMutation } from "@tanstack/react-query";
import { postSubmitSIAOrSIPA } from "../../../services/authApi";
import { uploadImage } from "../../../services/userManagementApi";
import { RxCross1 } from "react-icons/rx";

const validationSchema = yup.object({
  nomor: yup.string().required("nomor SIA wajib diisi"),
  expired: yup.string().required("tanggal kadaluarsa wajib di isi"),
  file: yup.mixed().required("file wajib diisi"),
});

const toDate = moment().format("YYYY-MM-DD");
const toDateApi = (date) => moment(date).format("YYYY-MM-DD");

const ModalSIA = (props) => {
  const { open, setOpen, onSuccessFunc } = props;

  const { mutate } = useMutation({
    mutationFn: postSubmitSIAOrSIPA,
    onSuccess: () => {
      if (onSuccessFunc) onSuccessFunc();
      setOpen(false);
      window.location.reload();
    },
  });

  const formik = useFormik({
    initialValues: {
      nomor: "",
      expired: toDate,
      file: "",
    },
    validationSchema,
    validateOnMount: true,
    onSubmit: (value) => {
      mutate({
        nomor: value.nomor,
        expired: value.expired,
        file: value.file,
        type: "sia",
      });
    },
  });

  const { mutate: mutateUploadImage } = useMutation({
    mutationFn: uploadImage,
    onSuccess: (data) => formik.setFieldValue("file", data.url),
  });

  return (
    <>
      {open ? (
        <form onSubmit={formik.handleSubmit}>
          <div className="justify-center items-center flex overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="px-8 pt-8 mb-4 flex justify-between items-center gap-4">
                  <div>
                    <p className="text-[#68A1F9] text-[18px] font-semibold">
                      Perbarui SIA
                    </p>
                    <p>
                      SIA anda sudah kadaluarsa, mohon perbarui SIA Anda ke yang
                      baru
                    </p>
                  </div>
                  <RxCross1
                    className="text-[16px] cursor-pointer text-red-500 hover:text-gray-300"
                    onClick={() => setOpen(false)}
                  />
                </div>

                <div className="flex justify-center flex-column px-8">
                  <TextField
                    fullWidth
                    sx={{ marginBottom: 2 }}
                    onChange={(e) =>
                      formik.setFieldValue("nomor", e.target.value)
                    }
                  />
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DesktopDatePicker
                      views={["year", "month", "day"]}
                      fullWidth
                      onChange={(newExpiredDate) =>
                        formik.setFieldValue(
                          "expired",
                          toDateApi(newExpiredDate)
                        )
                      }
                      value={formik.values.expired}
                      renderInput={(params) => {
                        return <TextField {...params} />;
                      }}
                      disablePast
                    />
                  </LocalizationProvider>
                </div>
                <div className="input-foto mb-4 px-8">
                  <div className="bg-blue-500 py-2 px-4 text-white font-medium flex mt-4 items-center gap-3 text-[14px] rounded-t-lg">
                    <span>
                      <BsImages />
                    </span>
                    Surat Izin Apotek
                  </div>

                  <div className="flex items-center justify-center h-25% border-2 border-solid rounded-b-lg">
                    {formik.values.file !== "" ? (
                      <label
                        htmlFor="drop"
                        className="cursor-pointer flex flex-col items-center justify-center w-[30%]"
                      >
                        <div className="relative">
                          <img
                            src={formik.values.file}
                            alt="foto produk"
                            className="h-[20%] rounded-lg shadow-md"
                          />
                        </div>
                        <input
                          id="drop"
                          type="file"
                          hidden
                          accept="accept='image/jpeg,image/png,image/jpg"
                          onChange={(e) => mutateUploadImage(e.target.files[0])}
                        />
                      </label>
                    ) : (
                      <label
                        htmlFor="dropzone-file1"
                        className="cursor-pointer flex flex-col items-center justify-center w-[100%] p-6"
                      >
                        <input
                          id="dropzone-file1"
                          hidden
                          type="file"
                          accept="image/jpeg, image/png, image/jpg"
                          onChange={(e) => mutateUploadImage(e.target.files[0])}
                        />
                        <div className="flex justify-center items-center flex-col text-center">
                          <FileUploadIcon sx={{ textAlign: "center" }} />
                          <p>Unggah SIA terbaru</p>
                        </div>
                      </label>
                    )}
                  </div>
                </div>
                {/*footer*/}
                <div className="flex font-semibold w-full justify-center px-8 pb-8">
                  <button
                    className="text-[#344054] border border-black p-2 rounded-md w-full hover:bg-gray-300"
                    onClick={() => setOpen(false)}
                  >
                    Batal
                  </button>
                  <button
                    className="text-white bg-[#007AF1] p-2 rounded-md ml-2 w-full hover:bg-gray-300 disabled:bg-gray-300"
                    type="submit"
                    disabled={!formik.isValid}
                  >
                    Ubah
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </form>
      ) : null}
    </>
  );
};

export default ModalSIA;
